import BaseService from './base.service'

export class UserService extends BaseService {
  static resource = 'user'

  static updateUserSettings(userSettings) {
    return this.post('UpdateUserSettings', userSettings)
  }

  static update(entity) {
    return this.post('profile', entity)
  }

  static getCurrent() {
    return this.get('current')
  }
}

export class ItemService extends BaseService {
  static resource = 'items'
}

export class ProcessService extends BaseService {
  static resource = 'processes'
}
